export const DEBOUNCE_DELAY = 700;

export const GERMANY_COUNTRY_CODE = 'DE';

export const COMPANY_FIELDS = {
  COUNTRY: 'companyCountry',
  POSTAL_CITY_ID: 'companyPostalCity',
  POSTAL_CODE: 'companyPostal',
  CITY: 'companyCity',
  DISTRICT_ID: 'companyRegionId',
  DISTRICT: 'companyRegion',
  STREET_ID: 'companyStreetId',
  STREET: 'companyStreet',
  HOUSE_NUMBER: 'companyHouseNumber',
  HOUSE_NUMBER_ADDITION: 'companyHouseNumberAddition',
};

/** Canonical keys that belong to the lokaref address block in task-detail messages. */
export const ADDRESS_MESSAGE_FIELD_KEYS = new Set(Object.values(COMPANY_FIELDS));

/** Lokaref lookup IDs used only by AddressInput — never sent back to EIV. */
export const ADDRESS_ID_FIELD_KEYS = new Set([
  COMPANY_FIELDS.POSTAL_CITY_ID,
  COMPANY_FIELDS.DISTRICT_ID,
  COMPANY_FIELDS.STREET_ID,
]);

/** Address keys sent back to EIV (excludes lokaref lookup IDs). */
export const ADDRESS_SUBMIT_FIELD_KEYS = Object.values(COMPANY_FIELDS).filter(
  (key) => !ADDRESS_ID_FIELD_KEYS.has(key)
);

export const FIELDS_TO_CLEAR_AFTER_COUNTRY = [
  COMPANY_FIELDS.POSTAL_CITY_ID,
  COMPANY_FIELDS.POSTAL_CODE,
  COMPANY_FIELDS.CITY,
  COMPANY_FIELDS.DISTRICT_ID,
  COMPANY_FIELDS.DISTRICT,
  COMPANY_FIELDS.STREET_ID,
  COMPANY_FIELDS.STREET,
  COMPANY_FIELDS.HOUSE_NUMBER,
  COMPANY_FIELDS.HOUSE_NUMBER_ADDITION,
];

export const FIELDS_TO_CLEAR_AFTER_CITY = [
  COMPANY_FIELDS.POSTAL_CODE,
  COMPANY_FIELDS.CITY,
  COMPANY_FIELDS.DISTRICT_ID,
  COMPANY_FIELDS.DISTRICT,
  COMPANY_FIELDS.STREET_ID,
  COMPANY_FIELDS.STREET,
  COMPANY_FIELDS.HOUSE_NUMBER,
  COMPANY_FIELDS.HOUSE_NUMBER_ADDITION,
];

export const FIELDS_TO_CLEAR_AFTER_DISTRICT = [
  COMPANY_FIELDS.STREET_ID,
  COMPANY_FIELDS.STREET,
  COMPANY_FIELDS.HOUSE_NUMBER,
  COMPANY_FIELDS.HOUSE_NUMBER_ADDITION,
];

export const FIELDS_TO_CLEAR_AFTER_STREET = [
  COMPANY_FIELDS.DISTRICT_ID,
  COMPANY_FIELDS.DISTRICT,
  COMPANY_FIELDS.HOUSE_NUMBER,
  COMPANY_FIELDS.HOUSE_NUMBER_ADDITION,
];

/** Cleared while typing in street; district stays until selection changes so Ortsteil stays in sync. */
export const FIELDS_TO_CLEAR_WHILE_TYPING_STREET = [
  COMPANY_FIELDS.HOUSE_NUMBER,
  COMPANY_FIELDS.HOUSE_NUMBER_ADDITION,
];

export const FIELDS_TO_CLEAR_AFTER_HOUSE_NUMBER = [COMPANY_FIELDS.HOUSE_NUMBER_ADDITION];
